/*
  Dabi Deri — ürün kartının üzerinde büyüyen önizleme.

  İmleç bir ürün görselinin üzerine gelince o görsel, tam üzerinde biraz
  büyüyerek açılıyor ve ürünün diğer görselleri içinde hızlıca geçiyor.
  Tıklayınca ürün sayfasına gidiyor.

  Sepet rozetiyle aynı yaklaşım: sayfada tek bir katman var ve olay
  delegasyonuyla imlecin altındaki karta taşınıyor. Kart şablonlarına
  dokunulmadığı için koleksiyon sayfaları, arama, ana sayfa şeritleri ve
  sonradan eklenecek bölümler aynı davranışı kendiliğinden alıyor.

  Görseller `/products/<handle>.js` ile okunuyor, handle başına bir kez
  önbelleğe alınıyor.
*/

(() => {
  const host = document.querySelector('[data-dabi-cardpeek]');
  if (!host) return;

  // Dokunmatikte "üzerine gelme" yok: önizleme ürüne BASILI TUTUNCA açılır (kısa dokunuş ve kaydırma
  // eskisi gibi). Ayar: Tema ayarları → Ürün üzerinde önizleme → Dokunmatikte basılı tutunca aç.
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const touchMode = !fine;
  if (touchMode && host.dataset.touch !== 'true') return;
  if (touchMode) host.classList.add('is-touch');

  const media = host.querySelector('[data-dabi-cardpeek-media]');
  if (!media) return;
  const caption = host.querySelector('[data-dabi-cardpeek-caption]');

  /* Kartın üzerindeki atölye rozeti (el simgesi) önizlemenin altında kalıp
     tıklanamıyordu. Rozet önizlemeye de kopyalanır: aynı yerde, tıklanınca
     atölyeye gider (fiyat ve sepete ekle rozeti gibi). data-dabi-peek-ignore:
     üzerine gelince önizleme ve sepet rozeti kapanmasın. */
  let extra = host.querySelector('[data-dabi-cardpeek-extra]');
  if (!extra) {
    extra = document.createElement('span');
    extra.className = 'dabi-peek__extra';
    extra.setAttribute('data-dabi-cardpeek-extra', '');
    extra.setAttribute('data-dabi-peek-ignore', '');
    host.appendChild(extra);
  }
  const copyBadges = (link, anchor) => {
    extra.innerHTML = '';
    const card = link.closest(CARD) || anchor.closest(CARD) || anchor;
    let badges = [...card.querySelectorAll('[data-dabi-wsb].dabi-wsb--corner, [data-dabi-mto]')];
    // şeritlerde (yuvarlak şerit, orbit, kategori paneli) kaynak rozet kartın kardeşi olarak durur
    if (!badges.length && card.parentElement) badges = [...card.parentElement.querySelectorAll(':scope > [data-dabi-mto], :scope > [data-dabi-wsb].dabi-wsb--corner')];
    if (!badges.length) badges = [...link.querySelectorAll('[data-dabi-wsb]')];
    badges.forEach((wsb) => {
      const c = wsb.cloneNode(true);
      c.removeAttribute('id');
      c.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
      c.querySelectorAll('[aria-describedby]').forEach((n) => n.removeAttribute('aria-describedby'));
      c.setAttribute('tabindex', '-1'); // klavyede kartın kendi rozeti kullanılır
      extra.appendChild(c);
    });
  };

  const cfg = host.dataset;
  const root = cfg.root || '/';
  const scale = Number(cfg.scale) || 1.25;
  const step = Number(cfg.speed) || 900;
  // Kucuk gorsel (cemberdeki yuvarlaklar gibi) en az bu boyuta buyur.
  const minSize = Number(cfg.min) || 0;

  /* Önizlemenin oturacağı görsel kutusu. Bağlantının içinde ya da dışında
     olabildiği için iki yönde de aranıyor. */
  const MEDIA =
    '.dabi-orbitcat__media, .dabi-shelf__media, .dabi-gallery__pop-media, .dabi-gribbon__media, .dabi-product-card__media, .card__media, .media';
  const CARD =
    '.dabi-orbitcat__card, .dabi-shelf__item, .dabi-gallery__pop-item, .dabi-gribbon__card, .dabi-product-card, .card-wrapper, .card, .grid__item';
  const SKIP =
    'header, .header, .header-wrapper, cart-drawer, cart-notification, .cart-item, .cart-items, .quick-add-modal, .dabi-qv, .dabi-iconrail, .product__media-list, [data-dabi-no-peek], [data-dabi-ticker], .dabi-wsb, .dabi-wsb-block, [data-dabi-mto], [data-dabi-deals], .dabi-camphub, .dabi-pricepop';

  const cache = new Map();

  /* Özel sipariş rozeti yedeği: kartta rozet yoksa (ör. yuvarlak şerit, menü) ürün bağlamında
     sections/dabi-mto-src istenir; ürün başına bir kez, boşsa da önbelleğe alınır. */
  const mtoCache = new Map();
  const loadMto = (handle) => {
    if (mtoCache.has(handle)) return mtoCache.get(handle);
    const req = fetch(`${root}products/${handle}?section_id=dabi-mto-src`, { headers: { Accept: 'text/html' } })
      .then((res) => (res.ok ? res.text() : ''))
      .then((html) => {
        if (!html) return null;
        const tpl = document.createElement('template');
        tpl.innerHTML = html;
        return tpl.content.querySelector('[data-dabi-mto]');
      })
      .catch(() => null);
    mtoCache.set(handle, req);
    return req;
  };

  /* Önizleme açıkken altındaki şerit durur (CSS animasyonu ya da JS kaydırma): .is-dabi-hold sözleşmesi.
     Bölüm CSS'i ve kaydırma döngüleri bu sınıfa bakar. */
  let held = null;
  const hold = (anchor) => {
    const sec = anchor && anchor.closest('.shopify-section');
    if (held === sec) return;
    if (held) held.classList.remove('is-dabi-hold');
    held = sec;
    if (held) held.classList.add('is-dabi-hold');
  };

  // dar önizlemede fiyat hapı sol alta uzanır; rozet sol üste geçer
  const tuneMto = () => {
    extra.querySelectorAll('[data-dabi-mto]').forEach((m) => m.classList.toggle('is-top', shownWidth < 440));
  };
  let current = null;
  let token = 0;
  let timer = null;
  let frame = null;

  const handleOf = (href) => {
    if (!href) return null;
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (err) {
      return null;
    }
  };

  const load = (handle) => {
    if (cache.has(handle)) return cache.get(handle);
    const request = fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
    cache.set(handle, request);
    return request;
  };

  const anchorFor = (link) => {
    // Baglanti pencerenin baska bir yerde acilmasini isteyebilir
    // (ornek: katalog cemberinde ortadaki daire).
    const at = link.dataset.dabiPeekAnchor;
    if (at) {
      const target = document.getElementById(at);
      if (target) return target;
    }
    const inside = link.closest(MEDIA);
    if (inside) return inside;
    const own = link.querySelector(MEDIA);
    if (own) return own;
    const card = link.closest(CARD);
    return (card && card.querySelector(MEDIA)) || link;
  };

  const stopCycle = () => {
    if (timer === null) return;
    window.clearInterval(timer);
    timer = null;
  };

  // Sekme arka plana alininca gorsel dongusu dursun.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopCycle();
  });

  const hide = () => {
    stopCycle();
    token += 1;
    current = null;
    host.dabiSource = null; // önizlemeyi açan bağlantı (başka bileşenler okuyabilir)
    host.classList.remove('is-visible');
    extra.innerHTML = '';
    hold(null);
  };

  // Bolum kendi en az boyutunu verebilir (data-dabi-peek-min).
  const minFor = (anchor) => {
    const own = anchor.closest('[data-dabi-peek-min]');
    return own ? Number(own.dataset.dabiPeekMin) || minSize : minSize;
  };

  let shownWidth = 0;

  const place = (anchor) => {
    const box = anchor.getBoundingClientRect();
    if (box.width === 0 || box.height === 0) return hide();
    if (box.bottom < 0 || box.top > window.innerHeight) return hide();

    // Balon görselin tam üzerinde, aynı oranda, biraz büyük. Küçük görsel
    // en az `minSize`a çıkarılıyor; ekran kenarından taşmasın diye merkez
    // sınırlanıyor. Sepet rozeti aynı hesabı yapıyor (dabi-add-badge.js).
    let w = box.width;
    let h = box.height;
    // Sigdirma: pencere hedefin olcusunde kalir, buyutulmez (ortadaki daire).
    const fit = anchor.hasAttribute('data-dabi-peek-fit');
    let k = fit ? 1 : touchMode ? Math.max(scale, 1.35) : scale; // telefonda biraz daha büyük
    // telefonda alttan panel açıksa önizleme panelin üstündeki boşluğa sığar
    const room = touchMode ? parseFloat(document.documentElement.dataset.peekRoom || '0') || 0 : 0;
    const min = fit ? 0 : minFor(anchor);
    if (w < min) {
      h *= min / w;
      w = min;
    }
    if (room) {
      // en az boyut uygulandıktan sonra: panelin üstündeki boşluğa sığdır (gerekirse en az boyutun da altına)
      const availH = window.innerHeight - room - 24;
      if (availH > 120 && h * k > availH) k = availH / h;
    }
    host.style.setProperty('--dabi-peek-scale', String(k));
    host.classList.toggle('is-round', anchor.hasAttribute('data-dabi-peek-round'));
    if (caption) {
      const text = anchor.dataset.dabiPeekCaption || '';
      caption.textContent = text;
      host.classList.toggle('has-caption', text !== '');
    }
    shownWidth = w * k;
    const halfW = (w * k) / 2;
    const halfH = (h * k) / 2;
    let cx = box.left + box.width / 2;
    let cy = box.top + box.height / 2;
    cx = Math.min(Math.max(cx, halfW + 8), window.innerWidth - halfW - 8);
    cy = Math.min(Math.max(cy, halfH + 8), window.innerHeight - (room || 0) - halfH - 8);
    host.style.width = `${w}px`;
    host.style.height = `${h}px`;
    host.style.left = `${cx}px`;
    host.style.top = `${cy}px`;
  };

  const fill = (product) => {
    // Urunun tum gorselleri (renk/versiyon fotograflari dahil) sirayla gecer.
    const shots = (product.images || []).slice(0, 10);
    if (shots.length === 0) return hide();

    media.innerHTML = '';
    shots.forEach((src, i) => {
      const img = document.createElement('img');
      // Shopify adresine boyut eklemek dosyayi kucultuyor.
      // Net gorsel: gosterilen boyutun ekran yogunluguyla carpimi kadar
      // genis dosya isteniyor (yuzluge yuvarlanir, 1600'de tavan).
      const want = Math.min(1600, Math.max(600, Math.ceil((shownWidth * (window.devicePixelRatio || 1)) / 100) * 100));
      img.src = src.includes('?') ? `${src}&width=${want}` : `${src}?width=${want}`;
      img.alt = '';
      img.width = want;
      img.height = want;
      if (i === 0) img.classList.add('is-active');
      media.appendChild(img);
    });

    host.classList.add('is-visible');

    if (shots.length < 2) return;
    let index = 0;
    timer = window.setInterval(() => {
      const frames = media.querySelectorAll('img');
      index = (index + 1) % frames.length;
      frames.forEach((f, i) => f.classList.toggle('is-active', i === index));
    }, step);
  };

  const show = async (link) => {
    const handle = handleOf(link.getAttribute('href'));
    if (!handle) return hide();

    const anchor = anchorFor(link);
    if (current && current.anchor === anchor) return;

    stopCycle();
    current = { anchor, handle, link };
    host.dabiSource = link;
    // ürün rafının (z 46) üstünde açılsın
    host.classList.toggle('is-over-shelf', !!link.closest('[data-dabi-shelf], [data-dabi-sheet-host]') || (touchMode && document.documentElement.classList.contains('is-dabi-sheet')));
    copyBadges(link, anchor);
    const mine = ++token;

    place(anchor);
    // place() önizlemeyi kapatmış olabilir (görsel ekran dışında): o zaman şerit tutulmaz
    if (mine !== token || !current) return;
    hold(anchor);
    tuneMto();
    if (!extra.querySelector('[data-dabi-mto]')) {
      loadMto(handle).then((el) => {
        if (!el || mine !== token || !current || extra.querySelector('[data-dabi-mto]')) return;
        const c = el.cloneNode(true);
        c.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
        c.querySelectorAll('[aria-describedby]').forEach((n) => n.removeAttribute('aria-describedby'));
        extra.appendChild(c);
        tuneMto();
      });
    }
    const product = await load(handle);
    if (mine !== token || !current) return;
    if (!product) return hide();
    place(anchor);
    fill(product);
  };

  if (fine) {
    document.addEventListener('pointerover', (event) => {
      const t = event.target;
      // Rozete uzanirken ya da "yok say" alaninin ustundeyken pencere degismesin.
      // özel sipariş baloncuğu (body'deki tek katman) önizlemeye aittir: üzerine geçince önizleme kapanmaz
      if (t.closest('[data-dabi-cardpeek], [data-dabi-addbadge], [data-dabi-peek-ignore], .dabi-mto-layer')) return;
      const link = t.closest('a[href*="/products/"]');
      if (!link || link.closest(SKIP)) {
        // Tutma bolgesinde (ornek: cember) gorseller arasindaki bosluktan
        // gecerken pencere kapanip acilmasin.
        if (!link && t.closest('[data-dabi-peek-keep]')) return;
        hide();
        return;
      }
      show(link);
    });

    document.documentElement.addEventListener('pointerleave', hide);
  }

  // Pencere imleci tutuyor (pointer-events: auto) ki rozete uzanirken
  // kapanmasin; tiklaninca altindaki kart gibi urune gider.
  host.addEventListener('click', (event) => {
    if (event.target.closest('[data-dabi-addbadge], [data-dabi-wsb], [data-dabi-mto]')) return;
    if (touchMode && performance.now() < swallowUntil) return; // basılı tutmanın bırakılışı
    const href = current && current.link && current.link.getAttribute('href');
    if (href) window.location.assign(href);
  });

  const follow = () => {
    frame = null;
    if (current) place(current.anchor);
  };

  const queue = () => {
    if (!current || frame !== null) return;
    frame = window.requestAnimationFrame(follow);
  };

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  // alttan panel büyüyünce / küçülünce önizleme kalan alana yeniden sığar
  document.addEventListener('dabi:peek:room', queue);

  host.style.setProperty('--dabi-peek-scale', String(scale));

  /* ---------- dokunmatik: basılı tut → önizleme ---------- */
  let swallowUntil = 0;
  if (touchMode) {
    const holdMs = Number(cfg.touchHold) || 400;
    const SKIP_T = SKIP.replace('.dabi-iconrail, ', ''); // ikon şeridinin kendi önizlemesi yalnız farede
    const INSIDE = '[data-dabi-cardpeek], [data-dabi-addbadge], [data-dabi-mto], .dabi-mto-layer, [data-dabi-pricepop], [data-qv-modal]';
    let lp = null;
    let opened = false;

    const cancel = () => {
      if (!lp) return;
      window.clearTimeout(lp.timer);
      lp = null;
    };
    const closeTouch = () => {
      if (!opened) return;
      opened = false;
      hide();
      document.dispatchEvent(new CustomEvent('dabi:peek:touchclose'));
    };
    const openTouch = async (link) => {
      opened = true;
      swallowUntil = performance.now() + 800;
      try { if (navigator.vibrate) navigator.vibrate(12); } catch (err) { /* yok */ }
      dismissHint(true);
      document.dispatchEvent(new CustomEvent('dabi:peek:touch', { detail: { link } }));
      await show(link);
      if (!opened || !current || current.link !== link) return;
      if (caption && cfg.touchCaption) {
        caption.textContent = cfg.touchCaption;
        host.classList.add('has-caption');
      }
    };

    document.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      const t = e.target;
      if (!t || !t.closest || t.closest(INSIDE)) return; // önizlemenin, rozetlerin, baloncuğun içi
      if (opened) closeTouch(); // dışarı dokunma kapatır
      const link = t.closest('a[href*="/products/"]');
      if (!link || link.closest(SKIP_T)) return;
      cancel();
      lp = { x: e.clientX, y: e.clientY, timer: window.setTimeout(() => { lp = null; openTouch(link); }, holdMs) };
    }, { passive: true });
    document.addEventListener('pointermove', (e) => {
      if (lp && Math.hypot(e.clientX - lp.x, e.clientY - lp.y) > 10) cancel();
    }, { passive: true });
    document.addEventListener('pointerup', cancel, { passive: true });
    document.addEventListener('pointercancel', cancel, { passive: true });
    // basılı tutarken tarayıcının bağlantı / görsel menüsü açılmasın; bırakılış tıklaması ürüne götürmesin
    document.addEventListener('contextmenu', (e) => { if (lp || performance.now() < swallowUntil) e.preventDefault(); });
    document.addEventListener('click', (e) => {
      if (performance.now() >= swallowUntil) return;
      e.preventDefault();
      e.stopPropagation();
      swallowUntil = 0;
    }, true);
    window.addEventListener('scroll', closeTouch, { passive: true });
    document.addEventListener('dabi:quickview:open', closeTouch);

    /* ilk ziyarette bir kez ipucu: ürün görseli ekrana gelince */
    let hintEl = null;
    const HINT_KEY = 'dabi-peek-hint';
    function dismissHint(used) {
      if (used) { try { localStorage.setItem(HINT_KEY, '1'); } catch (err) { /* yok */ } }
      if (!hintEl) return;
      hintEl.classList.remove('is-on');
      const el = hintEl;
      hintEl = null;
      window.setTimeout(() => el.remove(), 400);
    }
    const seen = () => { try { return localStorage.getItem(HINT_KEY) === '1'; } catch (err) { return true; } };
    if (cfg.touchHint && !seen() && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        io.disconnect();
        window.setTimeout(() => {
          if (seen() || opened) return;
          hintEl = document.createElement('div');
          hintEl.className = 'dabi-peek-hint';
          hintEl.setAttribute('role', 'status');
          hintEl.innerHTML = '<span class="dabi-peek-hint__ico" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-1.5a1.5 1.5 0 0 1 3 0V11m0-1a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1-6 6h-.6a5 5 0 0 1-3.9-1.9L5 15.4a1.6 1.6 0 0 1 2.4-2.1L9 15"/></svg></span><span class="dabi-peek-hint__txt"></span><button type="button" class="dabi-peek-hint__x" aria-label="×">×</button>';
          hintEl.querySelector('.dabi-peek-hint__txt').textContent = cfg.touchHint;
          hintEl.querySelector('button').addEventListener('click', () => dismissHint(true));
          document.body.appendChild(hintEl);
          window.setTimeout(() => hintEl && hintEl.classList.add('is-on'), 30);
          window.setTimeout(() => dismissHint(true), 7000);
        }, 900);
      }, { threshold: 0.6 });
      const firstImg = Array.from(document.querySelectorAll('a[href*="/products/"] img')).find((im) => !im.closest(SKIP_T));
      if (firstImg) io.observe(firstImg);
    }
  }
})();
